import React from 'react';
import {inject, observer} from 'mobx-react';
import {OpenEndedQuestionContent} from '../../../../../data/models/LessonContent/LessonContentBase';
import {lessonEditorText} from '../../../lessonEditorText';
import BaseOptionsContainer, {
  BaseContainerForwardProps,
  BaseContainerProps,
} from '../../BaseOptionsContainer';
import OpenEndedQuestionOptionsUI from '../view/OpenEndedQuestionOptionsUI';

const OpenEndedQuestionOptionsContainer = inject('lessonEditorStore')(
  observer(
    ({
      entityToEdit,
      isPublished,
      onEdit,
      onDelete,
      onSoftDelete,
      isLoading,
    }: BaseContainerForwardProps) => {
      const onSave = (
        gradeWeight: number,
        textAreaAnswerEnabled: boolean,
        textAreaAnswerPrompt: string,
        textAreaAnswerMaxCharacterCount: number,
        attachmentAnswerEnabled: boolean,
        attachmentAnswerPrompt: string,
        attachmentAnswerFileTypes: string[],
        attachmentAnswerMaxFileKb: number,
      ) => {
        onEdit({
          ...entityToEdit,
          gradeWeight,
          textAreaAnswerEnabled,
          textAreaAnswerPrompt,
          textAreaAnswerMaxCharacterCount,
          attachmentAnswerEnabled,
          attachmentAnswerPrompt,
          attachmentAnswerFileTypes,
          attachmentAnswerMaxFileKb,
        } as OpenEndedQuestionContent);
      };

      return entityToEdit ? (
        <>
          <OpenEndedQuestionOptionsUI
            entityToEdit={entityToEdit as OpenEndedQuestionContent}
            isLoading={isLoading}
            onSave={onSave}
            onDelete={onDelete}
            isPublished={isPublished}
            onSoftDelete={onSoftDelete}
          />
        </>
      ) : null;
    },
  ),
);

export default React.memo((props: BaseContainerProps) => (
  <BaseOptionsContainer
    {...props}
    deleteMessage={lessonEditorText.areYouSureDeleteImageSource}
    softDeleteMessage={lessonEditorText.areYouSureDeleteImageSourceSoft}>
    {forwardProps => <OpenEndedQuestionOptionsContainer {...forwardProps} />}
  </BaseOptionsContainer>
));
